import React from 'react';
import { useTranslation } from 'react-i18next';
import SignUpModal from '../../authentification/SignUpModal';
import styles from '../UserAccountLinker.module.scss'

const CreateAccount = ({setDisplaySignUpModal,setAccountCreate,setUserMailSignIn,setUserPasswordSignIn,senderOwner,setLastNameForEmailSucess,setNameForEmailSuccess,setSuccessLinked}) => {
    const { t } = useTranslation();
    return (
        <div className={styles.formCard}>
          <p className={styles.formTitle}>
            {t("invite.create_account_auto_link", { owner: senderOwner })}
          </p>
          <SignUpModal
            setDisplaySignUpModal={setDisplaySignUpModal}
            setAccountCreate={setAccountCreate}
            setUserPasswordSignIn={setUserPasswordSignIn}
            setNameForEmailSuccess={setNameForEmailSuccess}
            setLastNameForEmailSucess={setLastNameForEmailSucess}
            setSuccessLinked={setSuccessLinked}
          />
        </div>
    );
};

export default CreateAccount;